import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-[#0a0a0a] bg-gradient-to-r from-gold to-gold-light rounded-full hover:from-gold-light hover:to-gold transition-all duration-300 shadow-[0_0_20px_rgba(201,168,76,0.3)] hover:shadow-[0_0_30px_rgba(201,168,76,0.5)] transform hover:-translate-y-1';
  if (href) {
    return <motion.a href={href} className={`${`${`${`${`${baseStyles} ${className}`} pt-[16px] pb-[16px] mt-[10px] mb-[10px]`} pl-[40px] pr-[40px] mt-[-21px] mb-[-21px] ml-[0px] mr-[0px]`} mt-[-24px] mb-[-24px]`} mt-[-20px] mb-[-20px]`} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-146">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseStyles} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-147">
      {children}
    </motion.button>;
}